/* ============================================
   ENSOLIGHT — product page helpers
   --------------------------------------------
   1. Product image badges + zoom label (restored 31 Aug 2026).
   2. Mobile sticky buy bar (rebuilt 10 Sep 2026) — phones only,
      product pages only. Shows whenever the real "Add to bag"
      button is off screen (including on load); tapping it clicks the real button, so
      the bulb add-on / CTA-total logic runs exactly as normal.
      Styles: assets/enso-mobile-pdp.css (.enso-mbar*).
   3. Chat bubble gate (10 Sep 2026) — on phones the Shopify Inbox
      bubble is hidden by CSS until body.enso-chat-ready is set:
      after the first real scroll, or after 12 s.
   ============================================ */

/* 1. Inject product image badges + zoom label */
(function () {
  var badges = document.querySelector('.enso-image-badges');
  var zoomLabel = document.querySelector('.enso-zoom-label');
  var gallery = document.querySelector('slideshow-slides');
  if (!gallery) gallery = document.querySelector('slideshow-component');

  if (!gallery) {
    var productImages = document.querySelector('.product img[srcset]');
    if (productImages) gallery = productImages.closest('div[class]');
  }

  if (gallery) {
    gallery.style.position = 'relative';
    if (badges) gallery.prepend(badges);
    if (zoomLabel) gallery.appendChild(zoomLabel);

    gallery.addEventListener('mouseenter', function () {
      if (zoomLabel) zoomLabel.style.opacity = '1';
    });
    gallery.addEventListener('mouseleave', function () {
      if (zoomLabel) zoomLabel.style.opacity = '0';
    });
  }
})();

/* 2 + 3. Mobile sticky buy bar and chat gate */
(function () {
  var isPhone = window.matchMedia && window.matchMedia('(max-width: 749px)');
  if (!isPhone) return;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var info = document.querySelector('.product-information');
    var atc = document.querySelector(
      '.product-information button[name="add"], .product-information .add-to-cart-button, .product-information form[action*="/cart/add"] button[type="submit"]'
    );

    /* --- Chat gate: applies on every product page, phone only --- */
    if (info) {
      var chatReady = false;
      function releaseChat() {
        if (chatReady) return;
        chatReady = true;
        document.body.classList.add('enso-chat-ready');
        window.removeEventListener('scroll', onScrollForChat);
      }
      function onScrollForChat() {
        if (window.scrollY > 400) releaseChat();
      }
      window.addEventListener('scroll', onScrollForChat, { passive: true });
      setTimeout(releaseChat, 12000);
    }

    if (!info || !atc || !isPhone.matches) return;

    /* --- Sticky bar --- */
    var titleEl = info.querySelector('h1');
    var priceEl = info.querySelector('.price');

    var bar = document.createElement('div');
    bar.className = 'enso-mbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="enso-mbar__meta">' +
      '<span class="enso-mbar__title"></span>' +
      '<span class="enso-mbar__price"></span>' +
      '</div>' +
      '<button type="button" class="enso-mbar__btn">Add to bag</button>';
    document.body.appendChild(bar);

    var barTitle = bar.querySelector('.enso-mbar__title');
    var barPrice = bar.querySelector('.enso-mbar__price');
    var barBtn = bar.querySelector('.enso-mbar__btn');

    function sync() {
      var label = (atc.textContent || '').replace(/\s+/g, ' ').trim();
      // Real button reads "Add to bag — £40" once the CTA-total logic has run.
      var m = label.match(/(£[\d.,]+)/);
      barTitle.textContent = titleEl ? titleEl.textContent.trim() : '';
      barPrice.textContent = m ? m[1] : (priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '');
      var soldOut = atc.disabled || /sold out|unavailable/i.test(label);
      barBtn.textContent = soldOut ? 'Sold out' : (label.replace(/\s*[—–-]\s*£[\d.,]+.*$/, '') || 'Add to bag');
      barBtn.disabled = !!soldOut;
    }
    sync();
    try {
      new MutationObserver(sync).observe(atc, { childList: true, characterData: true, subtree: true, attributes: true });
      if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    } catch (e) {}

    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      atc.click();
    });

    function atcOnScreen() {
      if (!atc.offsetParent && getComputedStyle(atc).position !== 'fixed') return false; // display:none
      var r = atc.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    var ticking = false;
    function update() {
      // Show whenever the real button is off screen (incl. on load for products
      // with a long buy box) — that is the point of the bar on a phone.
      var show = !atcOnScreen() && isPhone.matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('enso-mbar-on', show);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    isPhone.addEventListener && isPhone.addEventListener('change', update);
    try { new MutationObserver(onScroll).observe(atc, { attributes: true, childList: true, subtree: true }); } catch (e) {}
    update();
  });
})();
